import { render, staticRenderFns } from "./transportacion.vue?vue&type=template&id=36af4d45&scoped=true"
import script from "./transportacion.vue?vue&type=script&lang=js"
export * from "./transportacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36af4d45",
  null
  
)

export default component.exports